import React, { useState, useEffect } from 'react';
import LogoWhitePulse from "../images/logo/pulseCIO_blanc_logo.png";
import LogoBlackPulse from "../images/logo/pulseCIO_black_logo.png";

const Footer = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    
    const updateTheme = () => {
      setIsDark(document.documentElement.classList.contains('dark'));
    };

    // Initial check
    updateTheme();

    // Watch for class changes
    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });

    // Listen for theme change events
    const handleThemeChange = () => updateTheme();
    window.addEventListener('theme-change', handleThemeChange);
    window.addEventListener('storage', handleThemeChange);

    return () => {
      observer.disconnect();
      window.removeEventListener('theme-change', handleThemeChange);
      window.removeEventListener('storage', handleThemeChange);
    };
  }, []);

  const gradientStyle = isDark
    ? {
        backgroundImage:
          'linear-gradient(180deg, rgba(17,24,39,1) 0%, rgba(59,130,246,0.12) 100%)',
      }
    : {
        backgroundImage:
          'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(37,99,235,0.06) 30%, rgba(59,130,246,0.08) 100%)',
      };

  return (
    <footer
      style={gradientStyle}
      className="mt-20 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900"
      aria-label="Pied de page"
    >
      {/* ...rest of footer content... */}
      <div className="container mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <div className="md:w-1/3 flex items-start gap-4 flex-col">
            <div className="flex-shrink-0 text-primary">
              <a href="/" aria-label="Accueil" className="inline-flex items-center gap-3">
                <img src={LogoBlackPulse} alt="PulseCIO" className="h-6 block dark:hidden" />
                <img src={LogoWhitePulse} alt="PulseCIO" className="h-6 hidden dark:block" />
                <span className="sr-only">PulseCIO</span>
              </a>
            </div>

            <div className="text-sm text-gray-600 dark:text-gray-400">
              © {new Date().getFullYear()} Mathieu Lalande - Tous droits réservés.
              <div className="mt-2 text-gray-500 dark:text-gray-400">
                Centralisez tous vos messages au même endroit, simplifiez la communication IT et améliorez la collaboration avec PulseCIO.
              </div>
              <div className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                Contact : <a className='text-blue-400' href="mailto:contact@pulsecio.com">contact@pulsecio.com</a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 md:w-2/3">
            <div>
              <h4 className="font-semibold mb-2 text-black dark:text-white">Produit</h4>
              <a href="/about" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                À propos
              </a>
              <a href="/status" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                Status
              </a>
              <a href="/#faq" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                FAQ
              </a>
              <a
                href="https://doc.pulsecio.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              >
                Documentation
              </a>
              <a
                href="https://app.pulsecio.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              >
                Application
              </a>
            </div>

            <div>
              <h4 className="font-semibold mb-2 text-black dark:text-white">Légal</h4>
              <a href="/legal" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                Mentions légales
              </a>
              <a href="/privacy" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                Politique de confidentialité
              </a>
              <a href="/cookies" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                Cookies
              </a>
              <a href="/terms" className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">
                CGU
              </a>
            </div>

            <div>
              <h4 className="font-semibold mb-2 text-black dark:text-white">Support</h4>
              <a
                href="mailto:contact@pulsecio.com"
                className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              >
                Contact
              </a>
              <a
                href="/#faq"
                className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              >
                FAQ
              </a>
              <a
                href="mailto:contact@pulsecio.com?subject=Signalement%20d%27un%20probl%C3%A8me"
                className="block hover:underline text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
              >
                Signaler un problème
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;